/**
 * 接口地址的统一管理
 */
const base = {
  url: process.env.VUE_APP_BASE_API
}
export default {

  company: {
    query: `${base.url}/cms/admin/company/list`,
    edit: `${base.url}/cms/admin/company/edit`,
    del: `${base.url}/cms/admin/company/del`,
    roles: `${base.url}/cms/admin/company/roles`,
    companySpiderSrcEdit: `${base.url}/cms/admin/companysrc/save`,
    companySpiderSrcQuery: `${base.url}/cms/admin/companysrc/list`
  },
  spider: {
    query: `${base.url}/cms/admin/spider/list`,
    edit: `${base.url}/cms/admin/spider/edit`,
    del: `${base.url}/cms/admin/spider/del`,
    test: `${base.url}/cms/admin/spider/test`,
    msg: `${base.url}/cms/admin/spider/msg`,
    ipProxy:`${base.url}/cms/admin/ipproxy/list`,
    ipProxyAdd:`${base.url}/cms/admin/ipproxy/add`,
  },
  product: {
    query: `${base.url}/cms/admin/product/list`,
    edit: `${base.url}/cms/admin/product/edit`,
    del: `${base.url}/cms/admin/product/del`,
    typeList: `${base.url}/cms/admin/product/types`,
    prentTypeList:`${base.url}/cms/admin/product/ptypes`
  },
  article: {
    query: `${base.url}/cms/admin/article/list`,
    detail: `${base.url}/cms/admin/article/detail`,
    edit: `${base.url}/cms/admin/article/edit`,
    del: `${base.url}/cms/admin/article/del`,
    original:`${base.url}/cms/admin/original/list`,
  },
  lang: {
    query: `${base.url}/cms/admin/lang/all`,
  },
  keywords:{
      query: `${base.url}/cms/admin/keywords/list`,
      edit: `${base.url}/cms/admin/keywords/edit`,
      del: `${base.url}/cms/admin/keywords/del`
    },
  type:{
      cascader: `${base.url}/cms/admin/type/cascader`,
      query: `${base.url}/cms/admin/type/list`,
      edit: `${base.url}/cms/admin/type/edit`,
      del: `${base.url}/cms/admin/type/del`
    },
  img: {
      imgUpload: `${base.url}/cms/admin/img/upload`,
      query: `${base.url}/cms/admin/img/list`,
      del: `${base.url}/cms/admin/img/del`,
    },
  kuaixun:{
    query:`${base.url}/cms/admin/kuaixun/list`,
  },
  calendar:{
    query:`${base.url}/cms/admin/calendar/list`,
  },
}


